import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { SiHeaderDropdownComponent, SiHeaderDropdownTriggerDirective } from '@siemens/element-ng/header-dropdown';
import { SiAvatarComponent } from '@siemens/element-ng/avatar';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SiHeaderDropdownComponent, SiHeaderDropdownTriggerDirective, SiAvatarComponent]
})
export class UserComponent {
    private readonly authService = inject(AuthService);

    protected readonly userName = this.authService.userName;
    protected readonly userPhoto = this.authService.userPhoto;
    protected readonly userOrgCode = computed(() => this.authService.userIdTokenClaims()?.org_code ?? '');
    protected readonly userInitials = computed(() => {
        const claims = this.authService.userIdTokenClaims();
        const given = claims?.given_name ?? '';
        const family = claims?.family_name ?? '';
        return `${given.charAt(0)}${family.charAt(0)}`.toUpperCase();
    });
}
